module.exports = __webpack_public_path__ + "static/media/audit_report_2017.859726b8.pdf";